/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { IDocumentRepository } from '@/modules/documents/domain/repositories/document.repository';

import { GetAllDocuments } from '../queries/get-all-documents';

export namespace CreateDocument {
  export type Input = IDocumentRepository.CreateInput;
  export type Output = IDocumentRepository.CreateOutput;

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const { repositories } = useDependencies();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn: (input) => repositories.document.create(input),
      async onSuccess(_, variables) {
        if (variables.siteIds.length === 0) {
          await queryClient.invalidateQueries({
            queryKey: GetAllDocuments.key({ siteId: undefined }),
          });
        } else {
          await Promise.all(
            variables.siteIds.map(async function (siteId) {
              await queryClient.invalidateQueries({
                queryKey: GetAllDocuments.key({ siteId }),
              });
            }),
          );
        }
      },
    });
  }
}
